export default (function (RootStates) {
    var parentState = RootStates.faq;

    return {
        faq: {
            name: 'faq',
            url: '/faq/{faqScrollTo}',
            parent: parentState,
            controller: function controller() {},
            template: '<gw-faq></gw-faq>',
            featureToggler: 'faq'
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/faq/config/RouteConfig.js
// module id = 948
// module chunks = 0